import React from "react"
import { Col, ListGroup, ListGroupItem, Row } from "react-bootstrap"
import { SingleSelectListingProps } from "../types/listing"
import "./singleSelectListing.scss"

const SingleSelectListing = ( props: SingleSelectListingProps) => {
    const headers = props.headers || []
    const displayableContent = props.displayableContent || new Map()
  
    const generateHeaderComponent = () => {
        let components: (JSX.Element)[] = []
    
        if (props.showHeaders) {
            const colElements = headers.map((header, index) => (
                <Col key={`col-${index}`} className="bold"> {header} </Col>
            ))
            components = [...colElements]
        }
        
        return <ListGroupItem className="bg-light">
            <Row>
                {components}
            </Row>
        </ListGroupItem>
    }

    const generateRows = () => {
        const rows: JSX.Element[] = []
        displayableContent.forEach((elements, id) => {
            rows.push(
                <ListGroup.Item key={`${id}`} action onClick={() => props.onSelect(id)}>
                    <Row>
                        {elements.map((element, colIndex) => (
                            <Col className={colIndex === 0 ? "strong" : ""} key={`col-${colIndex}`}>
                                {element}
                            </Col>
                        ))}
                    </Row>
                </ListGroup.Item>
            )
        })
        return rows
    }

    return (
        <>
            <ListGroup className="single-select-listing">
                {generateHeaderComponent()}
                {generateRows()}
            </ListGroup>
        </>
    )
}

export default SingleSelectListing



// WEBPACK FOOTER //
// ./src/common/listing/SingleSelectListing.tsx